<template>
  <div class="dashboard-header-container">
    <div class="dashboard-header">
      <div class="toggle" v-on:click="$emit('toggleSidebar')"></div>
      <div class="header-menu-item">{{ menuItem }}</div>

      <div class="search-and-notification-container">
        <div class="header-input-container">
          <input placeholder="Search something here...." />
        </div>

        <!-- Disable Chat and Notifications icons until feature implementation -->
        <!-- <div class="notifications-container">
          <div class="notifications-item">
            <div class="notification-count">20</div>
            <img src="../assets/images/messages-icon.svg" alt="Messages" />
          </div>

          <div class="notifications-item">
            <div class="notification-count">43</div>
            <img src="../assets/images/notifications-icon.svg" alt="Notifications" />
          </div>
        </div> -->

        <div class="profile-info-container">
          <div class="profile-image-container">
            <img v-if="profileUrl" v-bind:src="profileUrl" alt="Profile image" />
            <img v-else src="../assets/images/image-placeholder.png" alt="A placeholder image" />
          </div>

          <div class="profile-info">
            <div class="profile-name">{{ userName }}</div>
            <div v-if="userType !== ('Job Seeker' || 'normal-user')" class="profile-user-type">{{ userType }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DashboardHeader',
  props: ['menuItem', 'profileUrl', 'userName', 'userType'],
  data() {
    return {
      userData: '',
    };
  },
  computed: {
    getUserData() {

      return this.$store.state.userData;
    }
  },
  beforeMount() {
    this.$store.dispatch('fetchUserData');
  }
};
</script>

<style scoped>
  .dashboard-header-container {
    padding: 1.813rem 0 1.438rem 0;
    box-shadow: 0px 4px 4px rgba(138, 138, 138, 0.25);
    -webkit-box-shadow: 0px 4px 4px rgba(138, 138, 138, 0.25);
    -moz-box-shadow: 0px 4px 4px rgba(138, 138, 138, 0.25);
    background: var(--white);
    position: fixed;
    width: 82%;
    z-index: 2;
  }

  .toggle {
    width: 3.75rem;
    height: 3.75rem;
    display: none;
    background: var(--white);
    cursor: pointer;
    border: 1px solid var(--colorPrimary);
    margin-right: 1rem;
  }

  .toggle:before {
    content: "\f0c9";
    font-family: fontAwesome;
    width: 100%;
    height: 100%;
    line-height: 3.75rem;
    padding: 0.9375rem 0.9375rem 0.9375rem 1.25rem;
    font-size: 1.5rem;
    color: var(--colorSecondary);
  }

  .dashboard-header {
    color: black;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2.5rem 0 2.5rem;
  }

  .header-menu-item {
    flex-grow: 4;
    font-family: "gilroy", "sans-serif";
    color: var(--colorSecondary);
    font-weight: bold;
    font-size: 1.688rem;
  }

  .search-and-notification-container {
    flex-grow: 5;
    display: flex;
    /* justify-content: space-between; */
    justify-content: flex-end; /* Only use when header searchbar is disabled.
    Else if searchbar is enabled set css value to "space-around" or comment this line
    and uncomment the line above plus adjust .dashboard-header class padding */
    align-items: center;
  }

  .header-input-container {
    /* display: flex; */
    display: none;
    align-items: center;
    background: #eeeeee;
    padding: 1.063rem 2.5rem;
    width: 50%;
    border-radius: 60px;
  }

  .header-input-container input {
    background: none;
    font-size: 1rem;
    border: none;
    outline: none;
    width: 100%;
  }

  .header-input-container input::placeholder {
    color: #999999;
  }

  .header-input-container input::-webkit-input-placeholder {
    color: #999999;
  }

  .header-input-container input::-ms-input-placeholder {
    color: #999999;
  }

  .notifications-container {
    display: flex;
    align-items: center;
  }

  .notifications-item {
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #eeeeee;
    border-radius: 100%;
    width: 3.438rem;
    height: 3.438rem;
    margin-right: 1.375rem;
  }

  .notifications-item:hover {
    background: #dddddd;
  }

  .notifications-item:last-child {
    margin-right: 0;
  }

  .notification-count {
    background: #df2029;
    font-weight: 700;
    color: var(--white);
    font-size: 8px;
    line-height: 20px;
    text-align: center;
    top: 0;
    right: 0;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 100%;
  }

  .profile-info-container {
    text-align:right;
    display: flex;
    font-size: 1rem;
    align-items: center;
  }

  .profile-image-container {
    width: 55px;
    height: 55px;
  }

  .profile-image-container img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }

  .profile-info {
    padding-left: 0.5rem;
  }

  .profile-info-container .profile-name {
    font-weight: 700;
    color: var(--colorSecondary);
    line-height: 1.219rem;
    padding-bottom: 5px;
  }

  .profile-info-container .profile-user-type {
    font-weight: 500;
    color: #828282;
    line-height: 1.219rem;
  }

  @media only screen and (max-width: 1178px) {
    .header-menu-item {
      font-size: calc(1.688rem / 1.5);
    }

    .header-input-container {
      padding-top: calc(1.063rem / 1.5);
      padding-bottom: calc(1.063rem / 1.5);
    }

    .header-input-container input {
      font-size: 1rem;
    }

    .notifications-item {
      width: calc(3.438rem / 1.5);
      height: calc(3.438rem / 1.5);
      margin-right: calc(1.375rem / 2);
    }

    .notification-count {
      font-size: calc(8px / 1.1);
      line-height: calc(20px / 1.5);
      width: calc(20px / 1.5);
      height: calc(20px / 1.5);
    }
  }

  @media only screen and (max-width: 1078px) {
    .notifications-item {
      margin-right: calc(1.375rem / 4);
    }
  }

  @media only screen and (max-width: 990px) {
    .header-input-container {
      width: 35%;
      margin: 0 .5rem;
    }
  }

  @media only screen and (max-width: 767px) {
    .dashboard-header-container {
      width: 100%;
    }

    .toggle {
      display: block;
    }

    .dashboard-header {
      padding: 0 2.5rem;
    }

    .header-input-container {
      display: none;
    }

    .search-and-notification-container {
      /* justify-content: space-around; */
      justify-content: flex-end; /* Only use when header searchbar is disabled.
      Else if searchbar is enabled set css value to "space-around" or comment this line
      and uncomment the line above plus adjust .dashboard-header class padding */
    }
  }

  @media only screen and (max-width: 565px) {
  }

  @media only screen and (max-width: 460px) {
    .header-menu-item {
      display: none;
    }
  }

  @media only screen and (max-width: 420px) {
    .dashboard-header {
      padding: 0 1.1rem;
    }
  }
</style>
